class CascadeRegistry {
    private map = new Map<string, CascadeDefinition>();

    register(defs: CascadeDefinition[]) {
        defs.forEach(d => {
            this.map.set(d.property, d);
        });
    }

    get(property: string) {
        return this.map.get(property);
    }

    all() {
        return Array.from(this.map.values());
    }
}